<template>
    <DsCard class="start-from-scratch">
        <div>
            <NewIllustration :name="illustrationName" />
        </div>

        <strong>{{ $t('email.broadcast.unlayer.template.selection.common.startFromScratch') }}</strong>

        <p>{{ $t('unlayerBuilder.templateSelection.cards.fromScratch.description') }}</p>

        <DsOutlineButton
            :disabled="disabled"
            :loading="loading"
            @click="$emit('select')"
        >
            {{ $t('unlayerBuilder.templateSelection.cards.button.label.selectTemplate') }}
        </DsOutlineButton>
    </DsCard>
</template>

<script>
import NewIllustration from '@/components/funnel/ds-core-dupes/NewIllustration/NewIllustration.vue';

export default {
    components: {
        NewIllustration
    },

    props: {
        disabled: Boolean,
        loading: Boolean,
        emailsThryvThemeEnabled: Boolean,
    },

    computed: {
        illustrationName() {
            return this.emailsThryvThemeEnabled ? 'email-broadcasts-dex' : 'email-broadcasts';
        },
    },
};
</script>

<style lang="scss" scoped>
.start-from-scratch {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: $spacing-400;

    strong {
        margin: 0;
        text-align: center;
        font-size: $font-size-lg;
    }

    p {
        margin: 0;
        text-align: center;
        font-size: $font-size-sm;
        color: $color-text-subtle;
    }
}
</style>
